import React from "react";
import { useTranslation } from "react-i18next";

const RideSkipCountCell = ({ count }) => {
  const { t } = useTranslation();
  const n = Number(count) || 0;
  if (n <= 0) return <span style={{ color: "#94a3b8" }}>—</span>;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        background: "#fff7d6",
        color: "#8a6d00",
        border: "1px solid #f1e3a0",
        borderRadius: "999px",
        padding: "2px 10px",
        fontSize: "12px",
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      {t("rideSkip.count", { count: n })}
    </span>
  );
};

export default RideSkipCountCell;
